// extracted by mini-css-extract-plugin
var _1 = "PreviewColumn_column__6b518";
export { _1 as "column" }
